export default [
{
path: '/',
meta: {
    title: '运长安家',
    keepAlive: true
},
component: r => require.ensure([], () => r(require('../views/index/index')), `/index`),
}, 

{
    path: '/huayi',
    meta: {
        title: '运长安家-华宜建筑装饰',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/huayi')), `/huayi`),
}, 
{
    path: '/weige',
    meta: {
        title: '运长安家-维格家具装饰',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/weige')), `/weige`),
}, 
{
    path: '/jiameng',
    meta: {
        title: '运长安家-加盟合作',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/jiameng')), `/jiameng`),
}, 

{
    path: '/bangju',
    meta: {
        title: '运长安家-邦居公寓',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/bangju')), `/bangju`),
}, 

{
    path: '/xitong',
    meta: {
        title: '运长安家-系统合作',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/xitong')), `/xitong`),
}, 

{
    path: '/house',
    meta: {
        title: '我要找房',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/house/index')), `/house`),
}, 

{
path: '/propertydetail',
meta: {
    title: '门店详情',
    keepAlive: true
},
component: r => require.ensure([], () => r(require('../views/house/property_detail')), `/propertydetail`),
},



{
    path: '/error',
    meta: {
        title: '错误',
    },
    component: r => require.ensure([], () => r(require(`../views/error/index`)), `/error`),
},


{
    path: '/xitong_m',
    meta: {
        title: '运长安家-系统合作',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/xitong_m')), `/xitong_m`),
}, 
{
    path: '/jiameng_m',
    meta: {
        title: '运长安家-加盟合作',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/jiameng_m')), `/jiameng_m`),
},
{
    path: '/huayi_m',
    meta: {
        title: '运长安家-华宜建筑装饰',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/huayi_m')), `/huayi_m`),
}, 
{
    path: '/bangju_m',
    meta: {
        title: '运长安家-邦居公寓',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/bangju_m')), `/bangju_m`),
}, 
{
    path: '/index_m',
    meta: {
        title: '运长安家',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/index_m')), `/index_m`),
}, 
{
    path: '/weige_m',
    meta: {
        title: '维格家具装饰',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/weige_m')), `/weige_m`),
}, 

];


// WEBPACK FOOTER //
// ./src/router/config.js